function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "4.4c\\u2013-User-\\u2013-Library-\\u2013-Default-Overlay-option-2-Copy",
  transform: "translate(-881.000000, -535.000000)",
  fill: "#636363",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group-5",
  transform: "translate(117.000000, 136.000000)"
}, React.createElement("g", {
  id: "Group-8",
  transform: "translate(28.000000, 38.000000)"
}, React.createElement("g", {
  id: "blake-barlow-1499548-unsplash",
  transform: "translate(277.000000, 98.000000)"
}, React.createElement("g", {
  id: "Group-4",
  transform: "translate(-0.000000, 0.000000)"
}, React.createElement("path", {
  d: "M459.284023,269.247217 L464.225957,273.814552 C464.620441,274.178736 465.272988,274.190236 465.683461,273.840238 C466.093934,273.490241 466.106896,272.911282 465.712412,272.547098 C465.449423,272.304309 464.031617,270.993106 461.458994,268.61349 C464.031617,266.23387 465.449423,264.922665 465.712412,264.679876 C466.106896,264.315691 466.093934,263.736733 465.683461,263.386735 C465.272988,263.036738 464.620441,263.048238 464.225957,263.412422 L459.284023,267.979756 C459.09147,268.159151 458.989285,268.400233 459.000891,268.647746 C459.009248,268.871608 459.110008,269.084945 459.284023,269.247217 Z",
  id: "left-arrow",
  transform: "translate(462.500000, 268.613487) scale(-1, 1) rotate(-180.000000) translate(-462.500000, -268.613487) "
})))))));

const SvgLeftArrow = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "7px",
    height: "12px",
    viewBox: "0 0 7 12",
    ref: svgRef
  }, props), _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgLeftArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/left_arrow.5e57ec3c.svg";
export { ForwardRef as ReactComponent };